// WHO A TASK IS FOR, as a screen shows it. A task belongs to a client, or to nobody —
// an INTERNAL task (office work, the owners' own branding), which the server sends with
// `client: null` (or a null `client_id` on a list row). Every screen that heads a task
// with its client asks here, so "פנימי" is named once and the four screens that show
// tasks — the board, the bell, My Day and the lists — cannot name it differently.
import he from '../i18n/he';

export const INTERNAL_KEY = 'internal';

export const isInternal = (client) => client == null || client.id == null;

// { id, name, color } — the internal stand-in has no colour (the swatch goes muted).
export const taskClient = (client) => (isInternal(client)
  ? { id: null, name: he.tasks.internal, color: null }
  : client);
